<template>
  <div class="system-box">
    <!-- <el-form :model="eData" label-width="120px" > -->
    <el-form label-width="120px" >
      
      <FormEdit
        ref="FormEdit"
        :action="$api.url_upload_pu"
        :formItems="formItems"
        :areaIdsChecked="areaIdsChecked" />
        <!-- @watchChange="watchChange"
        @areaChange="areaChange" -->

      <el-form-item>
        <el-button type="primary" @click="submitHandler">提交</el-button>
        <!-- <el-button type="success" @click="addHandler">新增人事人才链接</el-button> -->
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
// import mixin_form from '@/Mixins/mixin_form'
import FormEdit from '@/components/FormEdit'
export default {
  // mixins: [mixin_form],
  components: { FormEdit },
  data() {
    return {
      sign: 'jzgd_zaixianqiuzhu',
      areaIdsChecked: this.areaId_x,
      // eData: {},
      // eData_ori: {},
      // times: {
      //   uploadFileList: 0,
      // },
    }
  },
  computed: {
    formItems() {
      return [
        { type: 'text', key: 'phone', label: '手机号码' },
        { type: 'botton', key: 'code', label: '验证码', btnType: '', btnText: '发送', callback: this.sendCode },
        { type: 'text', key: 'title', label: '标题' },
        { type: 'textarea', key: 'content', label: '内容' },
        { type: 'document', key: 'uploadFileList', label: '求助文件', limitNum: 3, index: 1 },
        // { type: 'text', key: 'okText', label: '处理状态' },
        // { type: 'text', key: 'dealOption', label: '处理意见' },
        // { type: 'document', key: 'dealFileList', label: '处理文件', limitNum: 3, index: 2 },
      ]
    },
    formItems2() {
      return null
    },
  },
  // watch: {
  //   areaIds_x(val) {
  //     this.areaChange(this.areaIds_x)
  //   }
  // },
  methods: {
    sendCode() {
      const result = this.$refs.FormEdit.submitHandler()
      console.log(`%c:`, 'color: #f00;', result)
      let phone = result.phone
      this.$api._user_SendCode({phone}).then(res => {
        if (res.data.status == 0) {
          this.$message.success('发送成功！')
        } else { this._status(res.data) }
      })
    },
//     areaChange(areaIds) { // 切换地区重新请求分站数据
//       console.log(areaIds)
//       let arr = JSON.parse(JSON.stringify(areaIds)).reverse()
//       let id = arr.find(x => x)
//       this.$api.getSystem(id).then(res => {
//         if (res.data.status == 0) {
//           let _R = JSON.parse(res.data.data)
//           console.log(`%c分站设置:`, 'color: #f00;', _R)
//           this.eData = _R
//           this.eData_ori = _R
//           this.$refs.FormEdit.eData = {}
// // ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
//           this.times.uploadFileList = _R.uploadFileList.length
// // ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
//           this.$refs.FormEdit.modifyHandler(this.eData)
//         } else { this._status(res.data) }
//       })
//     },
    // addHandler() {
    //   this.times.uploadFileList++
    //   this.$refs.FormEdit.eData.uploadFileList.push({ name: '', url: '' })
    //   // console.log(`%cformItems:`, 'color: #00f;', this.formItems)
    //   // console.log(`%ceData:`, 'color: #00f;', this.eData)
    // },
    submitHandler() {
      const result = this.$refs.FormEdit.submitHandler()
      // console.log(`%cresult:`, 'color: #00f;', result)
      let rData = {}
      let {
        id,province,city,county,town,village,
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        phone,
        code,
        title,
        content,
        uploadFileList,
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      } = result
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      if (!province) { this.$message.warning('请选择地区') }
      else if (!phone) { this.$message.warning('请填写手机号码') }
      else if (!code) { this.$message.warning('请填写验证码') }
      else if (!title) { this.$message.warning('请填写标题') }
      else if (!content) { this.$message.warning('请填写内容') }
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      else {
        const mapList_must = ['province', 'city', 'county', 'town', 'village']
        mapList_must.forEach(x => {
          rData[x] = result[x] || ''
        })
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        const mapList_unique = [
          'phone',
          'title',
          'content',
          'uploadFileList',
        ]
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        mapList_unique.forEach(x => {
          // if (JSON.stringify(this.eData_ori[x]) !== JSON.stringify(result[x])) {
            rData[x] = result[x]
          // }
        })
        console.log(`%crData:`, 'color: #00f;', rData)
        // this.$api.util_create(this.sign, rData).then(res => {
        //   if (res.data.status == 0) {
        //     this.$message.success('提交成功！')
        //   } else { this._status(res.data) }
        // })
        this.$api.zaixianqiuzhu_create(rData, phone, code).then(res => {
          if (res.data.status == 0) {
            this.$message.success('提交成功！')
          } else { this._status(res.data) }
        })
      }
    },

    // init() {
      // let {
      //   provinceId,
      //   cityId,
      //   countyId,
      //   townId,
      //   villageId
      // } = this.userInfo
      // let areaIds = [
      //   provinceId,
      //   cityId,
      //   countyId,
      //   townId,
      //   villageId
      // ]
      // this.areaChange(areaIds)
    // },
  },
  created() {
    // this.init()
  },
}
</script>

<style lang='scss' scoped>
.system-box{display: flex;justify-content: center;align-items: center;padding: 60px 0;}





/deep/ .upload-image .el-upload--picture-card,
/deep/ .upload-image .el-upload-list__item {width:90px;height:90px;position:relative;transition:none !important;} // 图片盒子大小
/deep/ .upload-image .el-icon-plus {width:28px;height:28px; position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;} // 图片加号位置
/deep/ .disabled .el-upload--picture-card {display:none} // 图片超出数量限制 隐藏上传按钮

/deep/ .el-form-item__label,
/deep/ .el-cascader__search-input,
/deep/ .el-radio__label {font-size: 12px;}

/deep/ .el-form-item {margin-bottom:10px;} // 设置每行间距


/deep/ .el-input--mini .el-input__icon {line-height: 36px;} // 选择器 icon位置


/deep/.el-select__tags{overflow: auto;}


// 视频 ↓
/deep/.upload-video .el-upload--text {border: 1px dashed #c0ccda;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
/deep/.upload-video .el-upload--text:hover {border-color: #409EFF;color: #409EFF;}
.upload-video-icon {
  width:90px;height:90px;line-height:90px;text-align: center;
  background-color: #fbfdff;font-size: 28px;color: #8c939d;
}
/deep/.el-upload-list--text{width: 400px;}
.video{width: 400px;max-height: 240px;}
/deep/ .disabled .el-upload--text{display: none;}
</style>